import { computed, onMounted, onBeforeUnmount, ref } from "vue";
import {
  BANOBAGI_CONNECTION_CUTOFF,
  BANOBAGI_SITE_CUTOFF,
  isBanobagiAvailabilityEnabled,
  isBanobagiConnectionClosed,
  isBanobagiSiteClosed
} from "@/utils/banobagiAvailability";

export function useBanobagiAvailability() {
  const now = ref(Date.now());
  let timer;

  function refreshAvailability() {
    clearTimeout(timer);
    now.value = Date.now();
    if (!isBanobagiAvailabilityEnabled()) return;
    const deadline = [BANOBAGI_CONNECTION_CUTOFF, BANOBAGI_SITE_CUTOFF].find(
      value => value > now.value
    );
    if (deadline) {
      timer = setTimeout(
        refreshAvailability,
        Math.min(deadline - now.value, 60000)
      );
    }
  }

  onMounted(() => {
    refreshAvailability();
    window.addEventListener("focus", refreshAvailability);
    document.addEventListener("visibilitychange", refreshAvailability);
  });
  onBeforeUnmount(() => {
    clearTimeout(timer);
    window.removeEventListener("focus", refreshAvailability);
    document.removeEventListener("visibilitychange", refreshAvailability);
  });

  return {
    isConnectionClosed: computed(() => isBanobagiConnectionClosed(now.value)),
    isSiteClosed: computed(() => isBanobagiSiteClosed(now.value)),
    refreshAvailability
  };
}
